<template>
  <div>
    <TheTopProgressBar :ratio="ratio"/>
    <TheHeader
      :forward-route="nextLink"
      :back-route="computedBackRoute"
    />
    <BaseSection
      v-if="opportunity"
      class="mb-12"
    >
      <BaseTitleGroup
        :subtitle="opportunity.data.attributes.name"
        :title="title"
        class="mb-2"
      />
      <BaseParagraph
        class="mb-6"
        v-html="opportunity.data.attributes[opportunityAttribute]"
      />
      <BaseParagraph
        class="italic text-xs mb-6"
        v-html="$t('Opportunity risks')"
      />
      <BaseButton
        :title="nextTitle"
        :to="nextLink"
        fixed-bottom
      />
    </BaseSection>
  </div>
</template>

<script>
import loadOpportunity from '../mixins/loadOpportunity';
import customBackRoute from '../mixins/customBackRoute';
import TheHeader from '../components/TheHeader.vue';
import BaseSection from '../components/BaseSection.vue';
import BaseTitleGroup from '../components/BaseTitleGroup.vue';
import BaseParagraph from '../components/BaseParagraph.vue';
import BaseButton from '../components/BaseButton.vue';
import TheTopProgressBar from '../components/TheTopProgressBar.vue';

export default {
  name: 'OpportunitySummary',
  components: {
    TheHeader,
    BaseSection,
    BaseTitleGroup,
    BaseParagraph,
    BaseButton,
    TheTopProgressBar,
  },
  mixins: [loadOpportunity, customBackRoute],
  props: {
    title: {
      type: String,
      required: true,
    },
    nextTitle: {
      type: String,
      required: true,
    },
    opportunityAttribute: {
      type: String,
      required: true,
    },
    nextLink: {
      type: String,
      required: true,
    },
    ratio: {
      type: Number,
      required: true,
    },
    backRoute: {
      type: String,
      required: true,
    },
  },
};
</script>
